var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1,.cls-4{stroke:#124882;stroke-linecap:round;stroke-linejoin:round;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:none;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{clip-path:url(#clip-path-4);}.cls-8{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 36.47 1 49.47 14.17 49.47 14.17 23.47 1 36.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.17 23.47 14.17 49.47 20.14 43.51 20.14 23.47 27.04 23.47 20.14 23.47 27.04 16.56 27.04 10.6 14.17 23.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.04 23.47 20.14 23.47 20.14 49.47 46.13 49.47 46.13 23.47 27.04 23.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.13 23.47 46.13 49.47 59 36.6 59 10.6 46.13 23.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33 10.6 27.04 16.56 20.14 23.47 46.13 23.47 59 10.6 33 10.6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 36.47 1 49.47 14.17 49.47 14.17 23.47 1 36.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 36.47 1 49.47 14.17 49.47 14.17 23.47 1 36.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.84,
    y: 23.16,
    width: 13.62,
    height: 26.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.84,
    y: 23.16,
    width: 13.62,
    height: 26.6
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1 36.47 1 49.47 14.17 49.47 14.17 23.47 1 36.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.04 10.6 14.17 23.47 14.17 49.47 27.04 36.6 27.04 10.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.17 23.47 14.17 49.47 20.14 43.51 20.14 23.47 27.04 23.47 20.14 23.47 27.04 16.56 27.04 10.6 14.17 23.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.03,
    y: 10.4,
    width: 13.19,
    height: 39.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.03,
    y: 10.4,
    width: 13.19,
    height: 39.36
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14.17 23.47 14.17 49.47 20.14 43.51 20.14 23.47 27.04 23.47 20.14 23.47 27.04 16.56 27.04 10.6 14.17 23.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33,
    y: 10.6,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.13,
    y: 23.47,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.04 23.47 20.14 23.47 20.14 49.47 46.13 49.47 46.13 23.47 27.04 23.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.87,
    y: 23.16,
    width: 26.38,
    height: 26.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.87,
    y: 23.16,
    width: 26.38,
    height: 26.6
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.04 23.47 20.14 23.47 20.14 49.47 46.13 49.47 46.13 23.47 27.04 23.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59 10.6 46.13 23.47 46.13 49.47 59 36.6 59 10.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.13 23.47 46.13 49.47 59 36.6 59 10.6 46.13 23.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.82,
    y: 10.4,
    width: 13.41,
    height: 39.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.82,
    y: 10.4,
    width: 13.41,
    height: 39.36
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "46.13 23.47 46.13 49.47 59 36.6 59 10.6 46.13 23.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33 10.6 20.14 23.47 46.13 23.47 59 10.6 33 10.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33 10.6 27.04 16.56 20.14 23.47 46.13 23.47 59 10.6 33 10.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.87,
    y: 10.4,
    width: 39.36,
    height: 13.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.87,
    y: 10.4,
    width: 39.36,
    height: 13.19
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "33 10.6 27.04 16.56 20.14 23.47 46.13 23.47 59 10.6 33 10.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/1_2.45f84004d78083f83f7adae20b0fdf5c.svg";
export { ForwardRef as ReactComponent };